module.exports = __webpack_public_path__ + "images/emoji/interrobang.d5af4be06261d524fbbc.png";